import React, { FC } from 'react';

import { HeaderFooterType } from '@/pages/layout/layout';
import { useStore } from '@/store/';

interface IGlobalState {
  children: React.ReactNode;
  headerFooterData?: HeaderFooterType;
  cartData?: object | null;
}

const GlobalState: FC<IGlobalState> = ({ children, headerFooterData, cartData }) => {
  const updateHeaderFooter = useStore(({ setHeaderFooter }) => setHeaderFooter);
  const updateCartData = useStore(({ setCartData }) => setCartData);

  updateHeaderFooter(headerFooterData!);

  updateCartData(cartData!);

  return <>{children}</>;
};

export default GlobalState;
